import { AbstractCache } from './abstract-cache';
import { ResolveFlagsResponse } from './generated/confidence/flags/resolver/v1/api';
import { Value } from './Value';
export class FlagCache extends AbstractCache {
    serialize(value) {
        return ResolveFlagsResponse.encode(value).finish();
    }
    deserialize(value) {
        return ResolveFlagsResponse.decode(value);
    }
    serializeKey(key) {
        return Value.serialize(key);
    }
    merge(newValue, oldValue) {
        if (newValue.resolveId === oldValue.resolveId) {
            for (let i = 0; i < newValue.resolvedFlags.length; i++) {
                const newFlag = newValue.resolvedFlags[i];
                const oldFlag = oldValue.resolvedFlags[i];
                newFlag.shouldApply = oldFlag.shouldApply;
            }
        }
        return newValue;
    }
    toOptions() {
        return {
            entries: this,
        };
    }
}
(function (FlagCache) {
    const singletonCaches = new Map();
    FlagCache.singletonScope = provider => {
        return clientKey => {
            let singletonCache = singletonCaches.get(clientKey);
            if (!singletonCache) {
                singletonCache = provider(clientKey);
                singletonCaches.set(clientKey, singletonCache);
            }
            return singletonCache;
        };
    };
    FlagCache.noScope = (provider) => provider;
    function defaultScope() {
        return typeof window === 'undefined' ? FlagCache.noScope : FlagCache.singletonScope;
    }
    function provider(clientKey, { scope = defaultScope(), entries }) {
        const provider = scope(() => new FlagCache());
        if (entries) {
            provider(clientKey).load(entries);
        }
        return provider;
    }
    FlagCache.provider = provider;
})(FlagCache || (FlagCache = {}));
//# sourceMappingURL=flag-cache.js.map